import { BlastEvent, SimulationConfig } from '@/types';
import { getRadiusAtAngle } from '@/logic/break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const VortexAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number
) => {
  for (let i = 0; i < 20; i++) {
    const pOffset = i / 20;
    const p = (progress + pOffset) % 1;
    const angle = p * Math.PI * 8 + (i * 0.4);
    const radiusBase = e.maxRadius * (1 - p * 0.5);
    const r = getRadiusAtAngle(angle, e, radiusBase);
    const px = e.pos.x + Math.cos(angle) * r;
    const py = e.pos.y + Math.sin(angle) * r;
    ctx.beginPath(); ctx.arc(px, py, 8 * (1 - p), 0, Math.PI * 2); ctx.fill();
  }
};

registerBlastAnimation('VORTEX', VortexAnimation);
